<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>Font Awesome</h1>
					<p waBody="m" waText>Font Awesome Free 7.2.0 &mdash; scalable vector icons &#40;Solid and Brands sets&#41; rendered via SVG with Angular FontAwesome integration and type-safe Java enum API. 2,000+ free icons with transformations, layering, masking, and animation effects.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Font Awesome 7.2.0</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:fontawesome</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.fontawesome5</p>
					<p waBody="s" waText>Built on: Font Awesome 7.2.0</p>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>INSTALLATION</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
						<markdown [data]="mdContent_93" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
						<markdown [data]="mdContent_94" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>NPM DEPENDENCIES &#40;auto-included&#41;</div>
					<markdown [data]="mdContent_95" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>COMPONENTS</div>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesome</h4>
								<p waBody="s" waColorText="quiet" waText>Icon component with style and icon enum selection</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.plugins.fontawesome5</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesomeIcons</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of 2,000+ free Solid icons</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.plugins.fontawesome5</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesomeBrandIcons</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of brand icons &#40;GitHub, Twitter, etc.&#41;</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.plugins.fontawesome5</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesomeLayers</h4>
								<p waBody="s" waColorText="quiet" waText>Layered icon container for combining multiple icons</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.plugins.fontawesome5</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesomeLayerCounter</h4>
								<p waBody="s" waColorText="quiet" waText>Counter badge overlaid on icon layers</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.plugins.fontawesome5</div>
							</div>
						</wa-card>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>FEATURES</div>
					<p waBody="s" waColorText="quiet" waText>2,000+ free icons &mdash; Font Awesome Free Solid and Brands icon sets</p>
					<p waBody="s" waColorText="quiet" waText>Type-safe Java enum API &mdash; FontAwesomeIcons and FontAwesomeBrandIcons with compile-time safety</p>
					<p waBody="s" waColorText="quiet" waText>Multiple icon styles &mdash; Solid and Brand styles included</p>
					<p waBody="s" waColorText="quiet" waText>SVG or Web Font rendering &mdash; choose between SVG core or classic CSS web fonts</p>
					<p waBody="s" waColorText="quiet" waText>Icon transformations &mdash; rotate, flip, scale, position with fluent API</p>
					<p waBody="s" waColorText="quiet" waText>Layering and masking &mdash; combine multiple icons with layers and masks</p>
					<p waBody="s" waColorText="quiet" waText>Animation effects &mdash; built-in spin, pulse, and custom animations</p>
					<p waBody="s" waColorText="quiet" waText>Sizing options &mdash; preset sizes from xs to 10x, or custom sizing</p>
					<p waBody="s" waColorText="quiet" waText>Angular FontAwesome module integration</p>
					<p waBody="s" waColorText="quiet" waText>CRTP fluent API for icon configuration</p>
					<p waBody="s" waColorText="quiet" waText>Zero configuration &mdash; auto-registered via ServiceLoader SPI</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<div waCaption="s" waFontWeight="semibold" waText>EXAMPLES</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Basic Icons</h4>
						<p waBody="s" waColorText="quiet" waText>Create solid and brand icons with animation.</p>
						<markdown [data]="mdContent_96" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Layered Icons</h4>
						<p waBody="s" waColorText="quiet" waText>Combine multiple icons with layers and counters.</p>
						<markdown [data]="mdContent_97" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
					<markdown [data]="mdContent_98" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINT DETAILS</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IPageConfigurator</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>FontAwesomePageConfigurator auto-registers fontawesome-svg-core and Angular FontAwesome module</p>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINTS</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>PREREQUISITES</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://fontawesome.com/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://fontawesome.com/docs</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/FontAwesome</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>